module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "socialButtons"
  }, [_c('div', {
    staticClass: "socialButtons_twitter"
  }, [_c('a', {
    attrs: {
      "href": _vm.tweetUrl,
      "rel": "nofollow",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "twitter_icon",
    attrs: {
      "src": require("assets/galmoji_twitter_icon.png")
    }
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('img', {
    staticClass: "shareyoro-img",
    attrs: {
      "src": require("assets/share_yoro.png")
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "socialButtons_hatena"
  }, [_c('a', {
    staticClass: "hatena-bookmark-button",
    attrs: {
      "href": "http://b.hatena.ne.jp/entry/s/tamanugi.github.io/galmoji_subtitle_player/",
      "data-hatena-bookmark-layout": "basic-counter",
      "title": "このエントリーをはてなブックマークに追加"
    }
  }, [_c('img', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "src": "https://b.st-hatena.com/images/entry-button/button-only@2x.png",
      "alt": "このエントリーをはてなブックマークに追加",
      "width": "20",
      "height": "20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c4596d7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialArea.vue
// module id = 224
// module chunks = 1